import { render, staticRenderFns } from "./AdvHomePart4.vue?vue&type=template&id=0edda8d7&scoped=true&"
import script from "./AdvHomePart4.vue?vue&type=script&lang=js&"
export * from "./AdvHomePart4.vue?vue&type=script&lang=js&"
import style0 from "./AdvHomePart4.vue?vue&type=style&index=0&id=0edda8d7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edda8d7",
  null
  
)

export default component.exports